import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import {
  faTwitter,
  faLinkedin,
  faGithub,
} from '@fortawesome/free-brands-svg-icons';

const contacts = [
  {
    link: 'https://twitter.com/Theophadh',
    icon: faTwitter,
  },
  {
    link: 'https://www.linkedin.com/in/theophile-kango/',
    icon: faLinkedin,
  },
  {
    link: 'https://github.com/Theophile-Kango',
    icon: faGithub,
  },
  {
    link: 'mailto:fadhili.kango@gmail.com',
    icon: faEnvelope,
  },
];

export default contacts;
